import axios from "axios";
import { config } from "../config";
import { authenticate, createResponseErrorHandler, parseDates, stringifyDates } from "./interceptors";

export const redemptionAppApi = axios.create({
    baseURL: `${config.redemptionApp.url}/`,
    headers: { "X-API-VERSION": config.redemptionApp.version },
});

redemptionAppApi.interceptors.request.use(authenticate);
redemptionAppApi.interceptors.request.use(stringifyDates);
redemptionAppApi.interceptors.response.use(parseDates, createResponseErrorHandler(redemptionAppApi));
